import React, { useContext } from 'react';
import { connect } from 'react-redux';

import { IsFromSearchContext } from '~/Providers/IsFromSearch';

import Members from '~/Components/Members/Members';
import mapDispatchToProps from '~/Components/ViewClanProfile/MapDispatchToProps';
import mapStateToProps from '~/Components/ViewClanProfile/MapStateToProps';

import type { MembersPropsType } from '~/Components/Members/Members';

interface PropsType extends MembersPropsType {}

const MembersContainer: React.FC<PropsType> = (props) => {
  const isFromSearch = useContext(IsFromSearchContext);

  return <Members {...props} isFromSearch={isFromSearch} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(MembersContainer);
